import { useInfiniteQuery } from "react-query";
import { z } from "zod";
import useApi from "hooks/useApi";
import { handleAxiosError } from "./utils";
import { RecentOrdersResponse, RecentOrdersResponseSchema } from "../Types/RecentOrders";

const RECENT_ORDERS_ENDPOINT = "/recent-orders";

/**
 * React Query hook for fetching recent orders
 * @returns Query object with recent orders data
 */
export default function useQueryRecentOrders(limit: number) {
  const api = useApi();

  const fetchRecentOrders = async ({ pageParam = null }) => {
    try {
      const { data } = await api.get(RECENT_ORDERS_ENDPOINT, {
        params: { lastTimestamp: pageParam, limit },
      });
      return RecentOrdersResponseSchema.parse(data);
    } catch (e) {
      if (e instanceof z.ZodError) {
        return Promise.reject(e.message);
      }
      return handleAxiosError(e);
    }
  };

  return useInfiniteQuery<RecentOrdersResponse, string>({
    queryKey: ["recentOrders"],
    queryFn: fetchRecentOrders,
    getNextPageParam: (lastPage) => lastPage.lastTimestamp ?? undefined,
    refetchOnWindowFocus: false,
  });
}
